import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import ContactCard from '../../../components/ContactCard';
import IconButtonsStack from '../../../components/IconButtonsStack';

const iconButtons = [
  {
    variant: 'icon-default',
    icon: light('phone'),
    size: 'lg',
    tooltipText: 'Call to 555-555-5555',
  },
  {
    variant: 'icon-default',
    icon: light('globe'),
    size: 'lg',
    tooltipText: 'Open website in new tab',
  },
];

export type AdditionalBenefitsProps = {
  showAdditionalBenefitsModal: boolean;
  handleCloseAdditionalBenefitsModal: () => void;
};

function AdditionalBenefitsModal({
  showAdditionalBenefitsModal,
  handleCloseAdditionalBenefitsModal,
}: AdditionalBenefitsProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showAdditionalBenefitsModal}
        onHide={handleCloseAdditionalBenefitsModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader>
          <h4 className="text-sm-20-lg-32">Additional Benefits</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            <Row>
              <Col className={'col-12 col-lg-6 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border'}
                  titleNode={
                    <div className="">
                      <span>Health Savings Account</span>
                      <span>Health Care Flexible Spending Account (HFSA)</span>
                      <span>
                        Dependent Care Flexible Spending Account (HFSA)
                      </span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'benefit-wallet.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
              <Col className={'col-12 col-lg-6 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border title-node'}
                  titleNode={
                    <div>
                      <span>Life Insurance</span>
                      <span>Accidental Death and Personal Loss Plan</span>
                      <span>
                        Personal & Family Accidental Death & Personal Loss (P&F
                        AD&PL)
                      </span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'prudential.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col className={'col-12 col-lg-6 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border '}
                  titleNode={
                    <div>
                      <span>Allstate Accident</span>
                      <span>Critical Illness and Hospital Indemnity</span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'allstate.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
              <Col className={'col-12 col-lg-6 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border'}
                  titleNode={
                    <div>
                      <span>Corestream A/H and Pet Insurancet</span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'corestream.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col className={'col-12 col-lg-4 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border'}
                  titleNode={
                    <div>
                      <span>Long Term Disability</span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'rls.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
              <Col className={'col-12 col-lg-4 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border'}
                  titleNode={
                    <div>
                      <span>EyeMed Vision</span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'eye-med.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
              <Col className={'col-12 col-lg-4 mb-7 mb-lg-10'}>
                <ContactCard
                  bg={'transperant-with-border'}
                  titleNode={
                    <div>
                      <span>ARAG Legal</span>
                    </div>
                  }
                  img={`${process.env.PUBLIC_URL}/${'arag.png'}`}
                  contactButtons={
                    <IconButtonsStack iconButtons={iconButtons} />
                  }
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseAdditionalBenefitsModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdditionalBenefitsModal;
